import $ from 'gridstrap/lib/gs-zepto';

export class SCWaitlistBottomBar {

	//
	// Properties
	//

	root;
	document;
	bottomBar;
	closeButton;
	modalButtons;

	get isClosed() { return localStorage.getItem('gsWaitlistDismissed') == 'true'; }
	set isClosed(value) { localStorage.setItem('gsWaitlistDismissed', (!!value).toString()); }

	//
	// Methods
	//

	close() {
		this.isClosed = true;
	}

	closeOnModalOpen() {
		this.document.one('gs:modalOpen', () => {
			this.bottomBar.dismiss();
			this.close();
		});
	}

	//
	// Initializations & Event Listeners
	//

	constructor(root) {
		this.root = $(root);
		this.document = $(document);
		if (this.isClosed) return this.root.remove();
	}

	gsOnInit() {
		this.bottomBar = this.root.find('.gs-BottomBar').gs(0);
		this.closeButton = this.root.find('button[role~="close"]');
		this.modalButtons = this.root.find('[data-gs-modal-template]');

		this.closeButton.on('click', () => this.close());
		this.modalButtons.on('click', () => this.closeOnModalOpen());
	}

	gsOnDestroy() {
		this.closeButton.off('click');
		this.modalButtons.off('click');
	}
}
